import instance from "./axios.base";

const getBanks = async () => {
  const res = await instance.get("/banks");
  return res.data;
};

export { getBanks };
